<template>
  <div id="pcm-app" class="sidebar-toggled">
    <router-view></router-view>
  </div>
</template>

<script>
import './assets/scss/sb-admin-2.scss'
export default {
  
}
</script>

